import { orderBy } from 'lodash';

import { Action } from '../../actions';
import {
    ADD_MARKETER_PRODUCT,
    CHANGE_MARKETER_ACCESS_CELL,
    CHANGE_MARKETER_ADD_PRODUCT_FORM,
    CHANGE_MARKETER_CARD_PAGE_STATUS,
    CHANGE_MARKETER_PRODUCT,
    FETCH_ADD_MARKETER_PRODUCT,
    FETCH_MARKETER_CARD_DATA,
    FETCH_REMOVE_MARKETER_PRODUCT,
    MARKETERS_OFFSET_GRID,
    REMOVE_MARKETER_PRODUCT,
    SORT_MARKETER_PRODUCTS,
    UPDATE_MARKETER_CARD_DATA,
    UPDATE_MARKETER_PRODUCT
} from '../../actions/marketers/marketerCard';
import { routeMarketerProductsToKeyMap } from '../../service/MarketersHelper';
import {
    MarketerAccess,
    MarketerCardData,
    MarketerProduct,
    MarketerProductsCellItem,
    MarketersPageStates
} from '../../typings/marketers';

export const marketerCardInitialState: MarketerCardData = {
    marketer: {
        id: '',
        login: '',
        fullName: '',
        ownProducts: []
    },
    pageStatus: MarketersPageStates.LOADING,
    productForm: {
        product: {
            productId: '',
            productName: ''
        },
        access: MarketerAccess.canRead,
        isEnabled: false
    },
    gridOffset: 0
};

export function marketerCard(
    state: MarketerCardData = marketerCardInitialState,
    action: Action
): MarketerCardData {
    switch (action.type) {
        case FETCH_MARKETER_CARD_DATA:
            return {
                ...state,
                pageStatus: MarketersPageStates.LOADING
            };

        case CHANGE_MARKETER_ADD_PRODUCT_FORM:
            return {
                ...state,
                productForm: {
                    ...state.productForm,
                    ...action.form
                }
            };

        case FETCH_ADD_MARKETER_PRODUCT:
            return {
                ...state,
                pageStatus: MarketersPageStates.FETCH_FORM
            };

        case UPDATE_MARKETER_CARD_DATA: {
            const ownProducts = action.sortParams
                ? orderBy<MarketerProduct[]>(
                      action.marketer.ownProducts,
                      [routeMarketerProductsToKeyMap[action.sortParams.key]],
                      [action.sortParams.direction]
                  )
                : action.marketer.ownProducts;

            return {
                ...state,
                marketer: {
                    ...action.marketer,
                    ownProducts: ownProducts.map((item: MarketerProduct) => {
                        return {
                            ...item,
                            selectedAccess: item.access,
                            isEdited: false,
                            isRemoving: false
                        };
                    })
                }
            };
        }

        case ADD_MARKETER_PRODUCT: {
            const addedProduct: MarketerProductsCellItem = {
                ...action.product,
                selectedAccess: action.product.access,
                isEdited: false,
                isRemoving: false
            };
            return {
                ...state,
                marketer: {
                    ...state.marketer,
                    ownProducts: action.sortParams
                        ? orderBy<MarketerProductsCellItem>(
                              [...state.marketer.ownProducts, addedProduct],
                              [
                                  routeMarketerProductsToKeyMap[
                                      action.sortParams.key
                                  ]
                              ],
                              [action.sortParams.direction]
                          )
                        : [...state.marketer.ownProducts, addedProduct]
                }
            };
        }

        case CHANGE_MARKETER_PRODUCT:
            return {
                ...state,
                pageStatus: MarketersPageStates.ACTION
            };

        case UPDATE_MARKETER_PRODUCT:
            return {
                ...state,
                marketer: {
                    ...state.marketer,
                    ownProducts: state.marketer.ownProducts.map(item => {
                        if (item.id === action.product.id) {
                            return {
                                ...action.product,
                                isEdited: false,
                                selectedAccess: action.product.access,
                                isRemoving: false
                            };
                        }

                        return item;
                    })
                }
            };

        case CHANGE_MARKETER_CARD_PAGE_STATUS:
            return {
                ...state,
                pageStatus: action.pageStatus
            };

        case CHANGE_MARKETER_ACCESS_CELL:
            return {
                ...state,
                marketer: {
                    ...state.marketer,
                    ownProducts: state.marketer.ownProducts.map(item => {
                        if (item.id === action.product.id) {
                            return { ...action.product };
                        }

                        return item;
                    })
                }
            };

        case FETCH_REMOVE_MARKETER_PRODUCT:
            return {
                ...state,
                marketer: {
                    ...state.marketer,
                    ownProducts: state.marketer.ownProducts.map(item => {
                        if (item.id === action.productId) {
                            return {
                                ...item,
                                isRemoving: true
                            };
                        }

                        return item;
                    })
                }
            };

        case REMOVE_MARKETER_PRODUCT:
            return {
                ...state,
                marketer: {
                    ...state.marketer,
                    ownProducts: state.marketer.ownProducts.filter(item => {
                        if (item.id === action.productId) {
                            return false;
                        }

                        return true;
                    })
                }
            };

        case MARKETERS_OFFSET_GRID:
            return {
                ...state,
                gridOffset: action.offset
            };
        case SORT_MARKETER_PRODUCTS:
            return {
                ...state,
                marketer: {
                    ...state.marketer,
                    ownProducts: orderBy<MarketerProductsCellItem>(
                        state.marketer.ownProducts,
                        [routeMarketerProductsToKeyMap[action.sortParams.key]],
                        [action.sortParams.direction]
                    )
                }
            };

        default:
            return state;
    }
}
